import tumblr from './tumblr.svg'
import lock from './lock-solid.svg'
import pen from './pen-fancy-solid.svg'
import magnifying_glass from './magnifying-glass-solid.svg'
import droplet from './droplet-solid.svg'
import heart from './heart-solid.svg'

const ICONS = {
  tumblr: tumblr,
  lock: lock,
  pen: pen,
  magnifying_glass: magnifying_glass,
  droplet: droplet,
  heart: heart,
}

export {ICONS}